import React, { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { sortDateTime } from "../../utils/utils";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import FileCopyIcon from "../../../../assets/svg/fileCopy.svg";
import { colorBrandObject } from "../../../../constants/brandings";
import { fileCopyDefaultColor } from "../../../reusableComponents/constants";

const showButtonStyle = {
  cursor: "pointer",
};

const ApiKeyField = ({ value }) => {
  const [showApiKey, setIsHidden] = useState(false);
  var dots = "                                       ";
  const handleClick = () => {
    setIsHidden(!showApiKey);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    customToast("success", "medium", `Key Copied`);
  };

  return (
    <div style={{ overflow: "hidden", display: "flex", marginLeft: "-12px" }}>
      <span>{dots.replace(/./g, "•")} </span>
      <div style={{ stroke: fileCopyDefaultColor }}>
        <FileCopyIcon stroke={`${colorBrandObject?.actionIconColor}`} onClick={handleCopy} style={showButtonStyle} />
      </div>
    </div>
  );
};
export const apiCredsSchema = {
  metadata: {
    title: "API Credentials",
    minHeight: 600,
    position: "relative",
    showTitle: false,
    rowHeight: 60,
    defaultSortInfo: { name: "addedDTime", dir: -1 },
  },
  fields: [
    {
      name: "id",
      header: "ID",
      visible: false,
      type: "string",
      filtering: false,
      // defaultWidth: 230,
      textAlign: "center",
    },
    {
      name: "name",
      header: "Name",
      visible: true,
      type: "string",
      filtering: false,
      textAlign: "center",
      minWidth: 200,
      defaultFlex: 1,
      sortable: false,
      render: ({ data }) => {
        return (
          <span style={{ display: "flex", marginLeft: "-12px" }}>
            {data?.name}
          </span>
        );
      },
    },
    {
      name: "businessUnitsNames",
      header: "Business Unit",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 250,
      defaultFlex: 1,
      textAlign: "center",
      sortable: false,
      render: ({ value }) => {
        const joinedBusinessUnits = value?.join(" ");
        return (
          <span
            style={{
              marginLeft: "-12px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <HoverToDisplayFullTitle title={joinedBusinessUnits} len={30} />
          </span>
        );
      },
    },
    {
      name: "addedDTime",
      header: "Added Time",
      visible: true,
      type: "string",
      filtering: false,
      textAlign: "center",
      defaultWidth: 550,
      minWidth: 300,
      defaultFlex: 1,
      sort: sortDateTime,
      render: ({ data }) => {
        return (
          <span style={{ display: "flex", marginLeft: "-12px" }}>
            {data?.addedDTime}
          </span>
        );
      },
    },
    {
      name: "apiKey",
      header: "API Key",
      visible: true,
      type: "string",
      filtering: false,
      defaultWidth: 620,
      textAlign: "center",
      sortable: false,
      // defaultFlex: 1,
      render: ApiKeyField,
    },
  ],
};
